module.exports = __webpack_public_path__ + "img/semestre.4ff0d189.png";